<template>
  <footer class="footer">
    <div class="footer__inner">

      <!-- Top: 4 columns -->
      <div class="footer__grid">

        <!-- Col 1: Brand -->
        <div class="footer__col footer__col--brand">
          <div class="footer__logo-wrap">
            <div class="footer__logo">
              <img :src="$app_image + 'Logo_SHC_Transparent.png'" alt="SHC" />
            </div>
            <div>
              <p class="footer__brand-name">{{ $t('companyName') }}</p>
              <p class="footer__brand-sub">Your Success Bridge</p>
            </div>
          </div>
          <p class="footer__tagline">{{ $t('footer.topConnect') }}</p>
          <p class="footer__tagline footer__tagline--gold">{{ $t('footer.maxProfit') }}</p>

          <div class="footer__socials">
            <a
              v-for="social in socialLinks"
              :key="social.name"
              :href="social.url"
              target="_blank"
              rel="noopener noreferrer"
              class="footer__social-btn"
              :aria-label="social.name"
            >
              <i :class="social.icon"></i>
            </a>
          </div>
        </div>

        <!-- Col 2: Company info -->
        <div class="footer__col">
          <h4 class="footer__col-title">{{ $t('footer.company.info') }}</h4>
          <dl class="footer__info-list">
            <div class="footer__info-row">
              <dt>{{ $t('footer.company.nameInfo') }}</dt>
              <dd>{{ $t('fullname') }}</dd>
            </div>
            <div class="footer__info-row">
              <dt>{{ $t('footer.company.taxCode') }}</dt>
              <dd class="footer__info-row--mono">0402139227</dd>
            </div>
            <div class="footer__info-row">
              <dt>{{ $t('common.address') }}</dt>
              <dd>{{ $t('addressBusiness') }}</dd>
            </div>
            <div class="footer__info-row">
              <dt>{{ $t('footer.company.foundingDate') }}</dt>
              <dd>15/03/2022</dd>
            </div>
            <div class="footer__info-row">
              <dt>{{ $t('footer.company.represent') }}</dt>
              <dd>{{ $t('representName') }}</dd>
            </div>
          </dl>
        </div>

        <!-- Col 3: Contact -->
        <div class="footer__col">
          <h4 class="footer__col-title">{{ $t('footer.contactInfo') }}</h4>
          <ul class="footer__contact-list">
            <li class="footer__contact-item">
              <i class="fas fa-envelope"></i>
              <div>
                <span class="footer__contact-label">{{ $t('common.email') }}</span>
                <a href="mailto:info.songhancapital@gmail.com" class="footer__contact-value">
                  info.songhancapital@gmail.com
                </a>
              </div>
            </li>
            <li class="footer__contact-item">
              <i class="fas fa-phone"></i>
              <div>
                <span class="footer__contact-label">{{ $t('common.tel') }}</span>
                <a :href="'tel:' + $t('tel')" class="footer__contact-value">{{ $t('tel') }}</a>
              </div>
            </li>
            <li class="footer__contact-item">
              <i class="fab fa-telegram"></i>
              <div>
                <span class="footer__contact-label">{{ $t('common.telegram') }}</span>
                <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="footer__contact-value">@SHC Rim</a>
              </div>
            </li>
            <li class="footer__contact-item">
              <i class="fab fa-whatsapp"></i>
              <div>
                <span class="footer__contact-label">WhatsApp</span>
                <a href="https://wa.me/84766726416" target="_blank" rel="noopener noreferrer" class="footer__contact-value">+84.766.726.416</a>
              </div>
            </li>
          </ul>
        </div>

        <!-- Col 4: Channels -->
        <div class="footer__col">
          <h4 class="footer__col-title">{{ $t('footer.telegram') }}</h4>
          <ul class="footer__channel-list">
            <li v-for="ch in telegramChannels" :key="ch.url">
              <a :href="ch.url" target="_blank" rel="noopener noreferrer" class="footer__channel-link">
                <i class="fab fa-telegram"></i>
                <span>{{ ch.name }}</span>
              </a>
            </li>
          </ul>

          <h4 class="footer__col-title footer__col-title--mt">{{ $t('footer.viber') }}</h4>
          <ul class="footer__channel-list">
            <li v-for="ch in viberChannels" :key="ch.url">
              <a :href="ch.url" target="_blank" rel="noopener noreferrer" class="footer__channel-link">
                <i class="fab fa-viber"></i>
                <span>{{ ch.name }}</span>
              </a>
            </li>
          </ul>
        </div>

      </div>

      <!-- Bottom bar -->
      <div class="footer__bottom">
        <p>© {{ new Date().getFullYear() }} {{ $t('fullname') }}. All rights reserved.</p>
      </div>

    </div>
  </footer>
</template>

<script>
import { i18n } from '@/config/i18n.js';

export default {
  name: 'AppFooter',
  data() {
    return {
      socialLinks: [
        { name: i18n.global.t('common.facebook'), url: 'https://www.facebook.com/songhancapitaldotcom', icon: 'fab fa-facebook-f' },
        { name: i18n.global.t('common.youtube'),  url: 'https://www.youtube.com/@songhancapital',      icon: 'fab fa-youtube'    },
      ],
      telegramChannels: [
        { name: i18n.global.t('footer.telegramChanel.thuvienshcchanel'),    url: 'https://t.me/thuvienshcchanel'      },
        { name: i18n.global.t('footer.telegramChanel.H4tradingview'),       url: 'https://t.me/H4tradingview'         },
        { name: i18n.global.t('footer.telegramChanel.ExnessSHCChallenger'), url: 'https://t.me/ExnessSHCChallenger'   },
        { name: i18n.global.t('footer.telegramChanel.preimercopier'),       url: 'https://t.me/preimercopier'         },
      ],
      viberChannels: [
        { name: i18n.global.t('footer.viberChanel.thuvienshcchanel'), url: 'https://invite.viber.com/?g2=AQAopqwM6sGd71OULVG3KnySR%2FToYcjc5AOT%2BBFFtAHIO%2BKZZAtQkknkSz5dZyAW' },
        { name: i18n.global.t('footer.viberChanel.preimercopier'),    url: 'https://invite.viber.com/?g2=AQBEdDN5XoZuPlOQYtpQiQlPVO1gU2hN5JT84SkVWJB3nB%2FS2epy1qN4mSZxA8Rs'    },
      ],
    };
  },
};
</script>

<style src="./AppFooter.scss" lang="scss"></style>
